import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { DataService } from 'src/app/services/data.service';

@Component({
  selector: 'app-seo-keyword-insight-detail',
  templateUrl: './seo-keyword-insight-detail.component.html',
  styleUrls: ['./seo-keyword-insight-detail.component.css']
})
export class SeoKeywordInsightDetailComponent implements OnInit {
  url: string = 'seoKeywordInsights';
  insightId: string = '';
  insight: any = null;
  loading: boolean = true;

  opportunityColumns: string[] = ['keyword', 'reason', 'priority'];

  constructor(
    private route: ActivatedRoute,
    private dataService: DataService
  ) { }

  ngOnInit(): void {
    this.insightId = this.route.snapshot.paramMap.get('id') || '';
    if (this.insightId) {
      this.loadDetail();
    }
  }

  loadDetail(): void {
    this.loading = true;
    this.dataService.getData(`${this.url}/${this.insightId}`).subscribe({
      next: (res) => {
        if (res.rst) {
          this.insight = res.data;
        }
        this.loading = false;
      },
      error: () => {
        this.loading = false;
      }
    });
  }
}
